import { ContactTypeScope } from 'constants/contactTypes';

export class ContactTypesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getContactTypes() {
    return this.#http.get('/contact-types');
  }

  async getEditorContactTypes() {
    return this.#http.get('/contact-types', { params: { scope: ContactTypeScope.ALL } });
  }

  async getExternalCodes(provider) {
    return this.#http.get('/contact-types/external-codes', { params: { provider } });
  }

  async createContactType(body) {
    return this.#http.post('/contact-types', body);
  }

  async updateContactType({ id, ...body }) {
    return this.#http.put(`/contact-types/${id}`, body);
  }

  async deleteContactType(id) {
    return this.#http.delete(`/contact-types/${id}`);
  }

  async deleteContactTypeMapping({ id, provider }) {
    return this.#http.delete(`/contact-types/${id}/mappings/${provider}`);
  }
}
